<div class="bg-default content-height pb-3 m-1">

  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>TeleCare Platform Terms of Use</a></div>
    </div>
  </div>
  <div class="Terms-data pl-5 pr-5">
    <h2>Last Updated: July 11, 2021</h2>
    <p>
      TeleSpecialists, LLC (“TeleSpecialists,” “our” or “we”), acting on behalf of its subsidiaries,
      affiliates, and licensors, provides this mobile app and TeleCare website (“TeleCare Platform” or
      the “Platform”) to you, the end user (“you” or “your” or “I”) in order to provide you access to
      certain telemedicine services, chat and quality data (“Services”) provided by TeleSpecialists’
      physicians (each a “Provider”). Except where expressly noted otherwise, the Platform consists
      of all pages located here: <a href="https://tstelecare.com" target="_blank">tstelecare.com</a>
      These Terms of Use (“Terms”) are a legal agreement between you and TeleSpecialists. By
      using this Platform, you expressly (1) agree to the terms of these Terms and the TeleCare
      Platform <span>Privacy Policy</span>, (2) affirm that you are physically located in the United States of
      America, and (3) consent to the collection and use of information as discussed in this Policy. If
      you do not agree with the Policy, do not use or access this Platform for any purpose.
      TeleSpecialists’ Terms of Use and Terms of Service do not apply to your use of the Platform.
    </p>
    <p>
      <b>
        Please read this agreement carefully before accessing or using the Platform. By
        accessing or using the Platform, you agree to the Terms. If you do not agree to
        these Terms, do not use the Platform.
      </b>
    </p>

    <h4>These Terms of Use May Change</h4>
    <p>
      TeleSpecialists may revise these terms from time to time. If we make any revisions, we will
      notify users by posting a notice regarding the revisions on this Platform. Revisions will be
      effective as of their posting unless otherwise stated. By accessing or using this Platform after
      such revisions are posted, you agree and consent to all such revisions. Do not use this Platform
      if you do not agree to the changes.
    </p>

    <h4>
      Platform Content and Access
    </h4>

    <p>
      TeleSpecialists reserves the right without prior notice to discontinue any Platform features,
      functions or content available on this Platform at any time without incurring any obligations to
      you or any other party. Statistics provided on this Platform are based upon patient and physician
      reporting and survey responses. Individual results from use of the Platform or Services may
      vary.
    </p>

    <h4>
      Ownership
    </h4>

    <p>
      The content on this Platform, including without limitation the text, graphics, logos, button icons,
      images, video and audio clips, digital downloads, data compilations and software, is owned or
      licensed by TeleSpecialists, the Providers or their respective affiliates or vendors and is
      protected under applicable United States and international patent, copyright, trademark and
      other intellectual property laws. The compilation of all content on this Platform, as well as the
      original arrangement, organization, design, formatting, trade dress, look and feel of the Platform
      is also the exclusive property of TeleSpecialists, the Providers or their respective affiliates or
      vendors and is also protected by United States and international intellectual property laws. This
      Platform may contain various third-party names and marks that are the property of their
      respective owners. Any unauthorized use of our marks or of our copyrighted material or trade dress or any other
      intellectual property is strictly prohibited and may be prosecuted to the fullest extent that the law
      provides.
    </p>

    <h4>
      Submissions
    </h4>

    <p>
      You may post or submit to the Platform various forms of content, pictures, feedback, comments,
      health information ideas or input and other content (“Content”). TeleSpecialists will not have any
      obligation of any kind to you with respect to any postings, feedback or data that you submit. You
      hereby grant to TeleSpecialists a perpetual, worldwide, royalty-free, irrevocable right and
      license in your Content and you agree to assign and hereby assign all such postings, feedback
      and data to TeleSpecialists without charge, which we may sublicense, to: (a) use, copy,
      reproduce, perform, display, publish and distribute (internally and externally) copies of, the
      Content (including any trademarks that consist of text or that are embedded or incorporated into
      such Content, e.g., a logo in a product image); and (b) adapt, modify, re-format and create
      derivative works of such Content which derivative works are also subject to the license set forth
      herein. Our rights to the Content will apply to the Content in any form or medium, whether now
      known or hereafter known.
    </p>

    <p>
      Any submissions through the Platform in connection with the Services will be maintained as
      confidential as required by law and TeleSpecialists’ obligations to the Providers.
    </p>

    <h4>
      License To Access
    </h4>

    <p>
      You are granted a limited, revocable license to access and make use of the Platform to view
      and use content contained on this Platform solely for your own personal or internal use,
      provided that: (1) it is used for informational and non-commercial purposes only; (2) no text,
      graphics or other content available from this Platform is modified or framed in any way; and (3)
      no graphics available from this Platform are used, copied or distributed separate from
      accompanying text. The use of any content for commercial purposes is expressly prohibited.
      Nothing in these Terms is intended to, or may be construed as, conferring by implication,
      estoppel or otherwise any license or other grant of right to use any patent, copyright, trademark,
      service mark or other intellectual property of TeleSpecialists or any third party, except as
      expressly provided in this section.
    </p>

    <h4>
      Acceptable Use of the Platform
    </h4>

    <p>
      You may not use, copy, modify, duplicate, distribute, translate, reproduce, republish,
      disassemble, reverse engineer, decompile, mirror, frame, hyperlink or transmit any of the
      content or materials of this Platform or rent or sell use of or access to (such as on a time share
      or service bureau basis) this Platform, or any of the content or materials on this Platform. You
      may not permit third parties to access this Platform or use any Platform content and may not
      make any other use of the Platform or any Platform content except as set forth in this
      Agreement, unless otherwise expressly agreed to in writing by TeleSpecialists. You may not
      harvest or collect information about others, including e-mail addresses. Any conduct by you that, in our
      discretion, restricts or inhibits any other person from using or enjoying the Platform will
      not be permitted.
    </p>

    <p>
      You understand and agree that TeleSpecialists may terminate or otherwise deny your access to
      the Platform without notice in the event TeleSpecialists believes in its sole discretion that (i) you
      have violated a provision of the Terms or Privacy Policy, (ii) you have used or misused the
      Platform in a manner that TeleSpecialists has determined is unlawful, unethical or otherwise
      inappropriate, or (iii) such action is reasonably necessary to protect a third party or
      TeleSpecialists or if such action is otherwise required by law.
    </p>

    <p>
      You acknowledge and agree (1) that your use of this Platform is at your own discretion and risk,
      (2) that use of any material, information or data downloaded or otherwise obtained through the
      use of this Platform is at your own discretion and risk, and (3) that you are solely responsible for
      any damage to your computer system for loss of data that results from the download of such
      material, information or data, and for any other form of damage that may be incurred.
    </p>

    <p>
      You will need an email address/user name and password to set up your Platform account. You
      are responsible for maintaining the confidentiality of your user name and/or password and for
      restricting access to your account. You agree to accept responsibility for all activities that occur
      under your account or password. You agree to provide only current, complete, accurate and
      truthful information. If you are accessing and using the Platform on someone else’s behalf, then
      you represent that you have the authority to bind that person as the principal to these Terms. To
      the extent you do not have such authority you agree to be bound to these Terms and to accept
      liability for harm caused by any wrongful use of the Terms resulting from your access or use.
      We reserve the right to refuse service and/or terminate accounts without prior notice if these
      Terms are violated or if we decide, in our sole discretion, that it would be in our best interests to
      do so.
    </p>

    <p>
      Except as otherwise agreed in writing, you will not (a) circumvent or attempt to circumvent,
      interfere, breach or abuse the security measures implemented to limit access and protect the
      Platform, information provided through use of TeleSpecialists, and the resources used to
      provide the Platform; (b) disrupt or interfere with the operation of the Platform or the resources
      used to provide the Platform; (c) transmit through the Platform any virus, trojan horse, or
      similarly harmful, disruptive or destructive computer program, script or object; (d) monitor,
      mirror, copy, summarize or create any derivative work from some or all the Platform or any
      materials used to provide the Platform (including the underlying software); (e) use another
      person’s account or password to access the Platform or otherwise obtain unauthorized access
      to the Platform or the data or information of another person; (f) use the Platform in any illegal
      manner or for any illegal purpose, or any other manner or purpose that would expose us or our
      service providers to civil or criminal liability; (g) use the Platform to transmit any form of
      unsolicited commercial e-mail or similar messages or otherwise use TeleSpecialists for
      commercial purposes; (h) transmit or communicate to us or our Service Providers any
      information that is illegal or which you do not have permission to transmit or communicate; (i)
      reverse engineer, decompile or reverse assemble any software used to provide the Platform; (j)
      use the Platform in any manner that could reasonably be expected to damage, disable,
      overburden or impair access to or the functionality of the Platform; (k) interfere with the security
      of, or otherwise abuse the Platform or the system resources, accounts, servers or networks that
      support, are connected to or are accessible through the Platform; and (l) attempt, or permit or
      authorize any other person to do, or omit to restrict any user from doing, any of the foregoing. We reserve the
      right to suspend or restrict the provision of the Platform as we determine in our
      sole discretion.
    </p>

    <h4>
      Third-Party Platforms and Third-Party Pages
    </h4>

    <p>
      This Platform may produce automated search results or otherwise link you to other websites on
      the Internet, called “Third Party Pages,” or may contain links to, or be accessed through links
      on, websites managed and operated by or on behalf of third party entities (“Third Party
      Platforms”). These third parties are separate and independent entities and are not agents of
      TeleSpecialists. TeleSpecialists does not have control over such third-party websites or the
      content of such websites. As a result, TeleSpecialists does not endorse and does not have
      responsibility for the information, misinformation, errors, availability, operation or performance of
      any such third-party website to which this Platform may link or from which this Platform may be
      accessed.
    </p>

    <p>
      Third-Party Pages and Third-Party Platforms have terms of use that are different from the
      TeleSpecialists and TeleCare Terms of Use and Privacy Policy, as applicable. You should
      carefully read the terms of use and privacy policies of these Third-Party Pages and Third-Party
      Platforms.
    </p>

    <h4>
      No Endorsements
    </h4>

    <p>
      Reference to any product, recording, event, process, publication, service, or offering of any third
      party by name, trade name, trademark, service mark, company name or otherwise does not
      constitute or imply the endorsement or recommendation of such by TeleSpecialists. Any views
      expressed by third parties on this Platform are solely the views of such third party and
      TeleSpecialists assumes no responsibility for the accuracy or veracity of any statement made by
      such third party.
    </p>

    <h4>
      Warranty Disclaimer
    </h4>

    <p>
      TeleSpecialists is a “covered entity” subject to the federal Health Insurance Portability &
      Accountability Act of 1996 and its implementing regulations (“HIPAA”), as amended from time to
      time. Pursuant to HIPAA and other applicable laws and regulations, we have taken reasonable
      and appropriate measures to ensure the security of the Platform and the technology that
      supports and enables the app and the Website. However, no electronic system can be
      absolutely secure or error-free. Our Notice of Privacy Practices explains how we use your health
      information.
    </p>
    <p>
      This Platform and all information, services and related materials it contains are provided “as is,”
      “as available” and “with all faults.” TeleSpecialists makes no representation or warranty
      whatsoever regarding the completeness, accuracy, currency, or adequacy of, or the suitability,
      functionality, availability, or operation of this Platform or the information or materials it contains.
      To the fullest extent permissible under applicable law, TeleSpecialsits, the Providers and their
      respective affiliates and vendors, specifically disclaim all warranties, express or implied, with
      respect to this website and the information and materials contained on this website, including without limitation
      the warranties of merchantability, fitness for a particular purpose, title and noninfringement and any warranties
      arising from a course of dealing or usage in trade
    </p>

    <p>
      Use of the Internet is inherently unreliable. As a result, neither TeleSpecialists nor the Providers
      warrant that the platform or your access to the platform will be uninterrupted or error-free, that
      defects in the platform will be corrected, or that this website or the server that makes it available
      are free of viruses or other harmful components. Neither TeleSpecialists nor the Providers
      warrant or make any representations regarding the use or the results of the use of the materials
      in this Platform in terms of their correctness, accuracy, reliability, or otherwise.
    </p>

    <p>
      While TeleSpecialists takes commercially reasonable efforts to protect the privacy and
      confidentiality of your information and transactions, TeleSpecialsits cannot ensure any internet
      transaction is completely secure. TeleSpecialists and its vendors use industry standard
      technology to help protect against the loss, misuse and alteration of the information under
      TeleSpecialists’ control; however, TeleSpecialists does not guarantee that such loss, misuse or
      alteration will not occur. You understand that use of the Internet and this Platform is at your own
      risk. Neither TeleSpecialists, the Providers, nor their respective vendors, affiliates or suppliers is
      responsible for any virus or damage to your computer, computer software, or any loss of data
      that may result from use of the website or access to any Services.
    </p>

    <p>
      This Platform may be unavailable from time to time due to mechanical, telecommunication,
      software, and third- party vendor failures. TeleSpecialists cannot predict or control when such
      downtime may occur and cannot control the duration of such downtime. As a result,
      TeleSpecialists cannot and does not have any liability for such failures.
    </p>

    <p>
      Reasonable efforts are taken to ensure the accuracy and integrity of information and related
      materials provided by TeleSpecialists on this Platform, but TeleSpecialists is not responsible for
      misprints, out-of-date information, technical or pricing inaccuracies, typographical or other
      errors. Information and related materials are subject to change without notice.
    </p>

    <p>
      No advice or information from TeleSpecialists or the Providers in any manner will create any
      warranty as to this Platform or any product, service or material available through this Platform. If
      for any reason you are not satisfied with this Platform or its content, your sole remedy is to
      cease using this Platform or such content, even if such remedy should fail of its essential
      purpose.
    </p>

    <p>
      Applicable law may not allow the exclusion of implied warranties, so the above exclusion may
      not apply to you.
    </p>

    <h4>
      Limitation of Liability
    </h4>

    <p>
      TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL
      TELESPECIALISTS, THE PROVIDERS, OR ANY OF THEIR RESPECTIVE VENDORS,
      AFFILIATES, OFFICERS, MEMBERS, REPRESENTATIVES, SUPPLIERS, DIRECTORS,
      EMPLOYEES, CONSULTANTS, OWNERS, OR AGENTS BE LIABLE FOR DAMAGES OF
      ANY KIND, INCLUDING WITHOUT LIMITATION ANY DAMAGES FOR LOSS OF USE; LOSS OF DATA, CONFIDENTIAL OR OTHER
      INFORMATION; LOSS OF PROFITS, BUSINESS,
      REVENUE, EXPECTED SAVINGS; BUSINESS INTERRUPTION; PERSONAL INJURY
      INCLUDING BODILY INJURY AND DAMAGE TO TANGIBLE PROPERTY; OR ANY DIRECT,
      SPECIAL, INDIRECT, INCIDENTAL, EXEMPLARY, PUNITIVE OR CONSEQUENTIAL
      DAMAGES ARISING FROM OR OTHERWISE RELATED TO THIS PLATFORM OR YOUR
      USE OF OR INABILITY TO USE THIS PLATFORM, WHETHER SUCH DAMAGES ARE
      BASED IN TORT, CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF
      TELESPECIALISTS HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR
      SUCH DAMAGES WERE OTHERWISE FORESEEABLE. YOUR SOLE AND EXCLUSIVE
      REMEDY IN THE EVENT OF SUCH DAMAGE IS TO DISCONTINUE YOUR ACCESS TO AND
      USE OF THIS PLATFORM. NOTWITHSTANDING THE FOREGOING, IN ANY EVENT, THE
      AGGREGATE LIABILITY OF TELESPECIALISTS, THE PROVIDERS AND THEIR AFFILIATES
      AND VENDORS FOR ANY REASON SHALL NOT EXCEED $100.00 US, EVEN IF SUCH
      REMEDY SHOULD FAIL OF ITS ESSENTIAL PURPOSE.
    </p>

    <h4>
      Indemnification
    </h4>

    <p>
      YOU AGREE TO DEFEND, INDEMNIFY AND HOLD HARMLESS TELESPECIALISTS, THE
      PROVIDERS, AND THEIR RESPECTIVE VENDORS, AFFILIATES AND THEIR OFFICERS,
      DIRECTORS, REPRESENTATIVES, EMPLOYEES, CONSULTANTS, AND AGENTS FROM
      AND AGAINST ANY CLAIMS, ALLEGATIONS, DAMAGES, LOSSES, LIABILITIES OR
      EXPENSES (INCLUDING, BUT NOT LIMITED TO ATTORNEYS’ FEES) THAT SUCH PARTY
      MAY SUFFER OR INCUR AS A RESULT OF (I) YOUR USE, MISUSE, OR INABILITY TO USE
      THE WEBSITE, (II) YOUR INFRINGEMENT OF ANY INTELLECTUAL PROPERTY OR
      OTHER RIGHT OF TELESPECIALISTS, OR ANY OTHER PERSON OR ENTITY, (III) YOUR
      VIOLATION OF ANY APPLICABLE LAW, INCLUDING WITHOUT LIMITATION ANY PRIVACY
      OR DATA SECURITY LAW OR REGULATION, OR (IV) YOUR VIOLATION OF THIS
      AGREEMENT. NOTWITHSTANDING THE FOREGOING, TELESPECIALISTS RESERVES
      THE RIGHT TO PARTICIPATE IN THE DEFENSE OF ANY SUCH CLAIM, SUBJECT TO
      YOUR INDEMNIFICATION OBLIGATION.
    </p>

    <h4>
      Disputes and Interpretation
    </h4>

    <p>
      This Agreement is governed by and interpreted under the laws of the State of Florida and the
      federal laws of the United States, without regard to conflicts of laws principles. Certain
      provisions, by their nature or as explicitly stated, will survive any termination or expiration of this
      Agreement. If any of these conditions shall be deemed invalid, void, or for any reason
      unenforceable, that condition will be severable and shall not affect the validity and enforceability
      of any remaining condition.
    </p>

    <p>
      These Terms of Use are the entire agreement and understanding between us and you and
      supersede all prior oral or written agreements and understandings relating to the subject matter
      of the Terms of Use. No statement, representation, warranty, covenant or agreement of any
      kind not expressly set forth in the Terms of Use will affect, or be used to interpret, change or
      restrict, the express terms and provisions of the Terms Use.
    </p>

    <h4>
      Digital Millennium Copyright Act
    </h4>

    <p>
      If you have any copyright concerns about materials posted on the Platform, you agree to let
      TeleSpecialists know. Pursuant to Title 17, United States Code, Section 512(C)(2), notifications
      of claimed copyright infringement should be sent to TeleSpecialists’ Designated Agent. An
      effective notification contains the following:
    </p>

    <ul>
      <li>
        A physical or electronic signature of a person authorized to act on behalf of the owner of
        an exclusive right that is allegedly infringed.
      </li>
      <li>
        Identification of the copyrighted work claimed to have been infringed, or, if multiple
        copyrighted works at a single online website are covered by a single notification, a
        representative list of such works at that website.
      </li>

      <li>
        Identification of the material that is claimed to be infringing or to be the subject of
        infringing activity and that is to be removed or access to which is to be disabled, and
        information reasonably sufficient to permit the service provider to locate the material.
      </li>

      <li>
        Information reasonably sufficient to permit the service provider to contact the complaining
        party, such as an address, telephone number, and, if available, an electronic mail address
        at which the complaining party may be contacted.
      </li>

      <li>
        A statement that the complaining party has a good faith belief that use of the material in
        the manner complained of is not authorized by the copyright owner, its agent, or the law.
      </li>
      <li>
        A statement that the information in the notification is accurate, and under penalty of
        perjury, that the complaining party is authorized to act on behalf of the owner of an
        exclusive right that is allegedly infringed.
      </li>
    </ul>

    <p>
      All inquiries not relevant to the following procedure will not receive a response.
    </p>

    <h4>
      Contact Us
    </h4>

    <p>
      The Platform is owned and operated by TeleSpecialist, LLC. If you have any questions
      about these Terms please contact us at:
    </p>

    <p class="mb-0">TeleSpecialists, LLC</p>
    <address class="mb-0">
      Attn: Legal Department <br>
      9110 College Pointe Ct<br>
      Example.com<br>
      Fort Myers, FL 33914
    </address>
    <a href="mailto:telecaresupport@tstelemed.com">telecaresupport@tstelemed.com</a>
  </div>
</div>
